<script lang="ts">
  type Icon = "plus" | "minus";

  export let icon: Icon;
  export let onClick: () => void;
  export let disabled: boolean = false;
</script>

<button
  class="flex items-center justify-center w-5 h-5 mb-[10px] rounded-full bg-gray-400 hover:bg-olli-500 text-white"
  on:click={() => onClick()}
  {disabled}
>
  {#if icon === "plus"}
    <svg
      xmlns="http://www.w3.org/2000/svg"
      class="h-4 w-4"
      viewBox="0 0 20 20"
      fill="#fff"
    >
      <path
        fill-rule="evenodd"
        d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z"
        clip-rule="evenodd"
      />
    </svg>
  {:else if icon === "minus"}
    <svg
      xmlns="http://www.w3.org/2000/svg"
      class="h-4 w-4"
      viewBox="0 0 20 20"
      fill="#fff"
    >
      <path
        fill-rule="evenodd"
        d="M5 10a1 1 0 011-1h8a1 1 0 110 2H6a1 1 0 01-1-1z"
        clip-rule="evenodd"
      />
    </svg>
  {/if}
</button>
